import TransactionsView from './TransactionsView'

export default TransactionsView
